import client from "./client";

const getProduct = (productID) => client.get("/products/getProduct/" + productID);
const validateAddress = (postcode) => client.get("/products/validateAddress/" + postcode);
const validateVehicle = (registration) => client.post("/products/validateVehicle/", { registration });
const getProducts = () => client.get("/products");
const uploadImage = (formdata) => client.post("/products/uploadImage", formdata);
const uploadImageNew = (productID, image) => client.post("/products/uploadImage", { productID, image });

const deleteImage = (productID, image) => client.post("/products/deleteImage", { productID, image });
const setPrice = (productID, price) => client.post("/products/setPrice", { productID, price });
const setDescription = (productID, description) => client.post("/products/setDescription", { productID, description });
const setComments = (productID, comments) => client.post("/products/setComments", { productID, comments });
const setStatus = (productID, status) => client.post("/products/setStatus", { productID, status });
const newProduct = (description, price, category, location, vehicle) =>
    client.post("/products/", {
        description,
        price,
        category,
        location,
        vehicle,
    });

const setLocation = (productID, location) => client.post("/products/setLocation", { productID, location });
const setCategory = (productID, category) => client.post("/products/setCategory", { productID, category });
const setVehicle = (productID, vehicle) => client.post("/products/setVehicle", { productID, vehicle });
const getMatching = (engineCode) => client.get("/products/getMatching/" + engineCode);

export default {
    getMatching,
    getProduct,
    getProducts,
    newProduct,
    deleteImage,
    uploadImage,
    uploadImageNew,
    setStatus,
    setDescription,
    setPrice,
    setComments,
    setLocation,
    validateVehicle,
    validateAddress,
    setCategory,
    setVehicle,
};
